var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStandardList = function SvgStandardList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.984 1.96a.98.98 0 1 1 0-1.96.98.98 0 1 1 0 1.96m3.454-.35a.62.62 0 0 1-.633-.626.62.62 0 0 1 .632-.632H15.11c.352 0 .633.273.633.632a.624.624 0 0 1-.633.625zM.984 7.422a.98.98 0 1 1 0-1.96.98.98 0 1 1 0 1.96m3.454-.352a.62.62 0 0 1-.633-.625.62.62 0 0 1 .632-.633H15.11c.352 0 .633.274.633.633a.624.624 0 0 1-.633.625zM.984 12.883a.98.98 0 1 1 0-1.96.98.98 0 1 1 0 1.96m3.454-.352a.62.62 0 0 1-.633-.625.62.62 0 0 1 .632-.633H15.11c.352 0 .633.274.633.633a.624.624 0 0 1-.633.625z"
  })));
};
export default SvgStandardList;